module.exports = __webpack_public_path__ + "assets/img/mecha-da42f601.png";